var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-pagination-wrapper"},[_c('el-pagination',{staticClass:"premium-pagination",attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"total":_vm.total,"layout":"total, sizes, prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }